export type ContactCompanyRef = {
  id?: unknown
}

export type ContactCompanySource = {
  company_id?: unknown
  companies?: Array<ContactCompanyRef | null> | null
}

function toPositiveId(value: unknown): number | null {
  const id = Number(value)
  if (!Number.isFinite(id) || id <= 0) {
    return null
  }
  return id
}

export function getContactCompanyIds(contact: ContactCompanySource | null | undefined): number[] {
  const ids = new Set<number>()
  if (contact && Array.isArray(contact.companies)) {
    contact.companies.forEach((company) => {
      const id = toPositiveId(company?.id)
      if (id !== null) {
        ids.add(id)
      }
    })
  }
  const primaryId = toPositiveId(contact?.company_id)
  if (primaryId !== null) {
    ids.add(primaryId)
  }
  return [...ids]
}
